import type { ComponentType, ReactNode } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useFormColors } from './FormThemeContext'
import { useResolveText } from '../i18n'
import { ACCENT, ACCENT_SOFT, FONT_DISPLAY } from '../tokens'

const MotionBox = motion.create(Box)

interface FormSectionProps {
  icon: ComponentType<{ size: number }>
  title?: string
  titleTid?: string
  description?: string
  descriptionTid?: string
  headerRight?: ReactNode
  delay?: number
  children: ReactNode
}

export function FormSection({
  icon: Icon,
  title,
  titleTid,
  description,
  descriptionTid,
  headerRight,
  delay = 0,
  children,
}: FormSectionProps) {
  const c = useFormColors()
  const resolve = useResolveText()
  const resolvedTitle = resolve(titleTid, title)
  const resolvedDescription = resolve(descriptionTid, description)

  return (
    <MotionBox
      mb={8}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
    >
      <Flex alignItems="center" justifyContent="space-between" mb={4}>
        <Flex alignItems="center" gap={3}>
          <Flex w="34px" h="34px" borderRadius="11px" align="center" justify="center" bg={ACCENT_SOFT} color={ACCENT} flexShrink={0}>
            <Icon size={17} />
          </Flex>
          <Box>
            <Text fontFamily={FONT_DISPLAY} fontSize="17px" fontWeight="700" color={c.text} letterSpacing="-0.02em">
              {resolvedTitle}
            </Text>
            {resolvedDescription && (
              <Text fontSize="sm" color={c.textMuted}>
                {resolvedDescription}
              </Text>
            )}
          </Box>
        </Flex>
        {headerRight}
      </Flex>
      <Box borderBottom="1px dashed" borderColor={c.border} mb={6} />
      {children}
    </MotionBox>
  )
}
